import { render, staticRenderFns } from "./MonitorDetailCheck.vue?vue&type=template&id=47f8f483&scoped=true&"
import script from "./MonitorDetailCheck.vue?vue&type=script&lang=js&"
export * from "./MonitorDetailCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8f483",
  null
  
)

export default component.exports